import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleLoginSignup = () => {
    if (!isMobile) {
      loginWithRedirect();
    }
  };

  return (
    <div className="login-page">
      {/* Left side with image preview */}
      <div className="login-preview">
        <img src="/dashboard-preview.png" alt="Dashboard Preview" className="preview-image" />
      </div>

      {/* Right side with form */}
      <div className="login-panel">
        <img src="/logo_new.png" alt="Reason Automation" className="logo" />
        <h1>Customer Portal</h1>
        <p className="subtitle">
          Reason Automation customers can create an account using Google, Microsoft, or an email address.
        </p>

        <div className="login-form">
          <button
            type="button"
            className={`login-signup-btn ${isMobile ? 'mobile-disabled' : ''}`}
            onClick={handleLoginSignup}
            disabled={isMobile}
          >
            {isMobile ? 'Please login on a desktop' : 'Login/Signup'}
          </button>
        </div>

        <div className="extra-links">
          <p>
            Not a Reason customer yet?{' '}
            <button
              className="talk-to-us-link"
              onClick={() => window.open('https://reasonautomation.com/demo', '_blank')}
            >
              Talk to us.
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
